"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Cosmos_1 = __importDefault(require("./Cosmos"));
const Osmosis_1 = __importDefault(require("./Osmosis"));
const Axelar_1 = __importDefault(require("./Axelar"));
const Desmos_1 = __importDefault(require("./Desmos"));
const Nyx_1 = __importDefault(require("./Nyx"));
const Onomy_1 = __importDefault(require("./Onomy"));
const Persistence_1 = __importDefault(require("./Persistence"));
const Quicksilver_1 = __importDefault(require("./Quicksilver"));
const SecretNetwork_1 = __importDefault(require("./SecretNetwork"));
const SeiNetwork_1 = __importDefault(require("./SeiNetwork"));
const Stargaze_1 = __importDefault(require("./Stargaze"));
const Stride_1 = __importDefault(require("./Stride"));
const Umee_1 = __importDefault(require("./Umee"));
const BinanceBeaconChain_1 = __importDefault(require("./BinanceBeaconChain"));
const cosmosChainParams = {};
function cryptoFactory(currencyId) {
    const initialized = currencyId === "osmosis" || currencyId === "osmo"
        ? cosmosChainParams["osmo"] != null
        : cosmosChainParams[currencyId] != null;
    if (!initialized) {
        switch (currencyId) {
            case "osmo":
            case "osmosis":
                cosmosChainParams["osmo"] = new Osmosis_1.default();
                return cosmosChainParams["osmo"];
            case "cosmos":
                cosmosChainParams[currencyId] = new Cosmos_1.default();
                break;
            case "axelar":
                cosmosChainParams[currencyId] = new Axelar_1.default();
                break;
            case "binance_beacon_chain":
                cosmosChainParams[currencyId] = new BinanceBeaconChain_1.default();
                break;
            case "desmos":
                cosmosChainParams[currencyId] = new Desmos_1.default();
                break;
            case "nyx":
                cosmosChainParams[currencyId] = new Nyx_1.default();
                break;
            case "onomy":
                cosmosChainParams[currencyId] = new Onomy_1.default();
                break;
            case "persistence":
                cosmosChainParams[currencyId] = new Persistence_1.default();
                break;
            case "quicksilver":
                cosmosChainParams[currencyId] = new Quicksilver_1.default();
                break;
            case "secret_network":
                cosmosChainParams[currencyId] = new SecretNetwork_1.default();
                break;
            case "sei_network":
                cosmosChainParams[currencyId] = new SeiNetwork_1.default();
                break;
            case "stargaze":
                cosmosChainParams[currencyId] = new Stargaze_1.default();
                break;
            case "stride":
                cosmosChainParams[currencyId] = new Stride_1.default();
                break;
            case "umee":
                cosmosChainParams[currencyId] = new Umee_1.default();
                break;
            default:
                throw new Error(`${currencyId} is not supported`);
        }
    }
    return cosmosChainParams[currencyId];
    // TODO: Currently, all cosmos currencies included setSupportedCurrencies must be supported here. We are working on a new way to support/enable new currencies
}
exports.default = cryptoFactory;
//# sourceMappingURL=chain.js.map